import { Middleware } from 'redux';

/**
 * Custom logger middleware that only logs in development mode
 */
export const loggerMiddleware: Middleware = (store) => (next) => (action: unknown) => {
  // Only log in development
  if (process.env.NODE_ENV !== 'production' && window.config.debug) {
    // Check if action is a plain object with a type property
    if (action && typeof action === 'object' && 'type' in action) {
      console.group(`ACTION: ${String(action.type)}`);
      console.info('dispatching', action);
      const result = next(action);
      console.log('next state', store.getState());
      console.groupEnd();
      return result;
    }
  }

  return next(action);
};
